import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import BaseLabel from '@/shared/legacy/ui/label/label.vue';
import BaseSelectDropdown from '@/shared/ui/base-list/base-select-dropdown.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'select',
  props: {
    id: {},
    items: { default: () => ([]) },
    placeholder: {},
    value: {},
    label: {},
    focus: { type: Boolean },
    customClass: {},
    style: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.customClass),
    style: _normalizeStyle(__props.style)
  }, [
    (__props.label)
      ? (_openBlock(), _createBlock(BaseLabel, {
          key: 0,
          class: _normalizeClass(_ctx.$style.labelContent),
          for: __props.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ]),
          _: 1
        }, 8, ["class", "for"]))
      : _createCommentVNode("", true),
    _createVNode(BaseSelectDropdown, _mergeProps(_ctx.$attrs, {
      placeholder: __props.placeholder,
      items: __props.items,
      "show-checkbox": "",
      "model-value": __props.value,
      focus: __props.focus,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('change', $event)))
    }), null, 16, ["placeholder", "items", "model-value", "focus"])
  ], 6))
}
}

})